import React from 'react';

type props = {
  Label: string;
  labelClass?: string;
  name?: string;
  value?: any;
  setValue?: (data: any) => void;
  inputType: 'text' | 'number' | 'boolean' | 'decimal' | 'tel' | 'date';
  Error?: any;
  ErrorMessage?: any;
  disabled?: boolean;
  allowDecimals?: boolean;
  secondLabel?: string;
  register?: any;
  enableAdornment?: boolean;
  placeholder?: string;
  dataTestId?: string;
  inputClassName?: string;
};

const CustomInput: React.FunctionComponent<props> = ({
  Label,
  labelClass,
  value,
  setValue,
  inputType,
  Error,
  ErrorMessage,
  disabled,
  name,
  allowDecimals,
  secondLabel,
  register,
  enableAdornment,
  placeholder,
  dataTestId,
  inputClassName,
}): JSX.Element => {
  const wrapperClass = inputClassName
    ? `flex w-full ${inputClassName}`
    : 'bg-gray-background-light flex w-full rounded-md';
  const inputClass = inputClassName
    ? `${inputClassName} w-full ${!enableAdornment ? 'px-3' : 'px'} py-2 text-sm leading-4 ${disabled ? 'cursor-not-allowed' : ''}`
    : `text-gray-dark bg-gray-background-light w-full rounded-md py-2 text-sm font-extrabold leading-4 focus:ring-transparent ${!enableAdornment ? 'px-3' : 'px'} ${disabled ? 'cursor-not-allowed' : null}`;
  const telProps =
    inputType === 'tel'
      ? {
          maxLength: 14,
        }
      : {};

  return (
    <div>
      <div className="flex justify-between">
        {Label.length > 0 && (
          <label htmlFor={dataTestId} className={`${labelClass} text-gray-dark mb-2 block leading-4`}>
            {' '}
            {Label}
          </label>
        )}
        {secondLabel && secondLabel?.length > 0 ? (
          <label htmlFor={dataTestId} className={`text-gray-dark mb-2 block text-xs leading-4`}>
            {' '}
            {secondLabel}
          </label>
        ) : null}
      </div>
      <div className={wrapperClass}>
        {enableAdornment && (
          <p className="text-gray-dark bg-gray-background-light my-2 ml-2 text-sm font-extrabold leading-4 focus:outline-none">
            $
          </p>
        )}{' '}
        <input
          id={dataTestId}
          data-testid={dataTestId}
          placeholder={placeholder}
          type={inputType === 'number' || inputType === 'decimal' ? 'text' : inputType}
          min={0}
          name={name}
          onWheel={(e: any) => e.target.blur()}
          value={value}
          disabled={disabled}
          className={inputClass}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (inputType === 'number') {
              const convertedValue = inputValue.replace(/\D/g, '');
              if (convertedValue !== value.toString()) {
                setValue && setValue(convertedValue);
              }
            } else if (inputType === 'decimal') {
              const validNumber = new RegExp(/^\d*\.?\d{0,3}$/);

              if (!validNumber.test(inputValue)) {
                e.preventDefault();
              } else {
                setValue && setValue(inputValue);
              }
            } else {
              setValue && setValue(inputValue);
            }
          }}
          {...telProps}
          {...register}
        />
      </div>
      {Error && <label className="text-red mb-2 block pt-2 text-xs font-medium leading-4"> {ErrorMessage}</label>}
    </div>
  );
};

export default CustomInput;
